import { createContext } from 'react'

export const WidthContext = createContext()
